import { createHttpClient } from '@shared/adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useInfiniteQuery } from '@tanstack/react-query';
import { ReusedApiAdapter } from '../adapters';
import { Filters } from '../models';
import { Service } from '../services/Service';

export const useReused = (filters: Filters = {}) => {
    const httpClient = createHttpClient(apiClientWH);
    const apiAdapter = new ReusedApiAdapter(httpClient);
    const service = new Service(apiAdapter);

    const {
        data,
        isLoading,
        isFetching,
        error,
        refetch,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
        isPending,
    } = useInfiniteQuery({
        queryKey: ['reused', filters],
        queryFn: ({ pageParam = 1 }) =>
            service.getPaginated({
                ...filters,
                page: pageParam,
            }),
        getNextPageParam: (lastPage) => lastPage.nextPage,
        initialPageParam: 1,
        staleTime: 5 * 60 * 1000,
        placeholderData: (previousData) => previousData,
    });

    const reused = data?.pages.flatMap((page) => page.reused) ?? [];

    // Obtener el total del API (siempre será el mismo en todas las páginas)
    const totalFromApi = data?.pages?.[0]?.total ?? 0;

    return {
        reused,
        isLoading: isLoading || isPending,
        isFetching,
        error,
        refetch,
        // Nuevas props para scroll infinito
        fetchNextPage,
        hasNextPage: hasNextPage ?? false,
        isFetchingNextPage,
        // Stats útiles
        totalPages: data?.pages.length ?? 0,
        totalReceptions: reused.length,
        total: totalFromApi,
    };
};

